import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface JobSubmittedDialogProps {
  open: boolean;
  onClose: () => void;
  jobId: string;
  documentName?: string;
}

const JobSubmittedDialog: React.FC<JobSubmittedDialogProps> = ({
  open,
  onClose,
  jobId,
  documentName
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <CheckCircleIcon color="success" />
          <Typography variant="h6">
            Document Indexing Job Submitted
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Alert severity="success" sx={{ mb: 2 }}>
          Your document has been successfully submitted for indexing.
        </Alert>
        
        {documentName && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Document: <strong>{documentName}</strong>
          </Typography>
        )}
        
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Job ID:
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ 
            backgroundColor: 'grey.100', 
            padding: 1, 
            borderRadius: 1,
            fontFamily: 'monospace',
            wordBreak: 'break-all'
          }}
        >
          {jobId}
        </Typography>
        
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          The indexing process is running in the background. The document lists will be refreshed when you close this dialog.
        </Typography>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default JobSubmittedDialog;
